import React from 'react';
import Loader from 'react-loader';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SectionItem from './SectionItem';

import './SectionedItems.css';

const SectionedItems = props => {
  const {
    className,
    hasSeparators,
    itemType: ItemType,
    list,
    loading,
    seeAllLabel,
    seeAllLink,
    title,
    disableClick,
    actorLoader
  } = props;

  const wrapperClass = classnames('sectioned-items__wrapper', className);
  const itemClass = classnames('sectioned-items__item', {
    'sectioned-items__item--bordered': hasSeparators
  });

  if (actorLoader && loading) {
    return (
      <div className={wrapperClass}>
        <ul className="sectioned-items__list">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(p => (
            <li
              className={classnames(itemClass, {
                'sectioned-items__item--last': p === 10,
                'sectioned-items__item--top': p === 1
              })}
              key={`sectioned-items__loading-${p}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="115"
                height="218"
                viewBox="0 0 115 218"
              >
                <defs>
                  <linearGradient
                    id="dh9frx00na"
                    x1="0%"
                    x2="100%"
                    y1="50%"
                    y2="50%"
                  >
                    <stop offset="0%" stopColor="#EEEEEE" />
                    <stop offset="33%" stopColor="#EEEEEE" />
                    <stop offset="50%" stopColor="#f5f5f5" />
                    <stop offset="67%" stopColor="#EEEEEE" />
                    <stop offset="100%" stopColor="#EEEEEE" />
                    <animateTransform
                      attributeName="gradientTransform"
                      type="translate"
                      from="-1 0"
                      to="1 0"
                      begin="0s"
                      dur="1.5s"
                      repeatCount="indefinite"
                    />
                  </linearGradient>
                </defs>
                <path
                  fill="url(#dh9frx00na)"
                  fillRule="evenodd"
                  d="M132 232v14H17v-14h115zm0-18v14H17v-14h115zm-8-186c4.418 0 8 3.582 8 8v159c0 4.418-3.582 8-8 8H25c-4.418 0-8-3.582-8-8V36c0-4.418 3.582-8 8-8h99z"
                  transform="translate(-17 -28)"
                />
              </svg>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className={wrapperClass}>
      {(title || seeAllLink) && (
        <div className="sectioned-items__header">
          {title && <h3 className="sectioned-items__title">{title}</h3>}
          {seeAllLink && (
            <a className="sectioned-items__more-link" href={seeAllLink}>
              {seeAllLabel}
            </a>
          )}
        </div>
      )}

      <Loader
        lines={13}
        loaded={!loading}
        loadedClassName="sectioned-items sectioned-items--loaded"
        parentClassName="sectioned-items sectioned-items--loading"
        position="relative"
        width={2}
      >
        <ul className="sectioned-items__list">
          {list.map((p, idx) => (
            <li
              className={classnames(itemClass, {
                'sectioned-items__item--last': idx === list.length - 1,
                'sectioned-items__item--top': p.top
              })}
              key={`${p.value || p.name}-${p.label || p.score}`}
            >
              <ItemType disableClick={disableClick} item={p} index={idx} />
            </li>
          ))}
        </ul>
      </Loader>
    </div>
  );
};

SectionedItems.propTypes = {
  className: PropTypes.string,
  hasSeparators: PropTypes.bool,
  itemType: PropTypes.func,
  list: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      })
    ),
    PropTypes.arrayOf(
      PropTypes.shape({
        score: PropTypes.string,
        name: PropTypes.string
      })
    )
  ]).isRequired,
  loading: PropTypes.bool,
  seeAllLabel: PropTypes.string,
  seeAllLink: PropTypes.string,
  title: PropTypes.string,
  disableClick: PropTypes.bool,
  actorLoader: PropTypes.bool
};

SectionedItems.defaultProps = {
  className: '',
  hasSeparators: true,
  itemType: SectionItem,
  loading: false,
  seeAllLabel: 'See All',
  seeAllLink: '',
  title: '',
  disableClick: false,
  actorLoader: false
};

export default SectionedItems;
